<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t('accountingGiven'))"
      icon="mdi-file-tree"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :filterable="false"
      :create-label="$t('newGiven')"
      @refresh="getItems"
      @print="printStudio = true"
      @create="newGiven"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-model="selected"
        v-column-resize="accountingGivenColumnPlugins"
        v-column-drag="accountingGivenColumnPlugins"
        v-column-pin="accountingGivenColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        :page.sync="page"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                class="pl-action-cell__btn"
                v-bind="attrs"
                icon
                x-small
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="editGiven(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                linkgi
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
          <span class="pl-action-cell__row">{{
            parseInt(items.indexOf(item)) + parseInt(from)
          }}</span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.kind="{ item }">
          {{ $t(item.kind) }}
        </template>
        <template v-slot:item.total_id="{ item }">
          {{ $t(item.total.name) }}
        </template>
        <template v-slot:item.group_id="{ item }">
          {{ $t(item.total.group.name) }}
        </template>
        <template v-slot:item.some="{ item }">
          <v-icon
            v-if="item.some == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.tracking="{ item }">
          <v-icon
            v-if="item.tracking == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.interpretable="{ item }">
          <v-icon
            v-if="item.interpretable == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.currencyFeature="{ item }">
          <v-icon
            v-if="item.currencyFeature == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.type="{ item }">
          <div class="pt-1">
            {{ $t(item.type) }}
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <a
            @click="editGiven(item)"
          >
            {{ item.name }}
          </a>
        </template>
        <template v-slot:item.number="{ item }">
          <a
            @click="editGiven(item)"
          >
            {{ item.total.group.number }}{{ item.total.number }}{{ item.number }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.content="{ item }">
          {{ item.content ? item.content : 'ندارد' }}
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t('accountingGiven'))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="false"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t('newGiven')"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @create="newGiven"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t('accountingGiven'))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <!--    given dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="givenDialog"
      width="100%"
      max-width="450px"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="givenDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('given') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <given
            :item="givenItem"
            @close="closeDialog"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    filter dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="type"
              :label="$t('natureAccount')"
              :items="typeItems"
              height="30"
              dense
              outlined
              multiple
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    tasl dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    delete dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="40%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col class="text-right">
            <v-radio-group v-model="printType">
              <template v-slot:label>
                <div class="text-right">
                  {{ $t('chooseTemplate') }}
                </div>
              </template>
              <v-radio value="document">
                <template v-slot:label>
                  <div>{{ $t('totalGivenDetails') }}</div>
                </template>
              </v-radio>
              <v-radio value="document1">
                <template v-slot:label>
                  <div>{{ $t('totalGiven') }}</div>
                </template>
              </v-radio>
              <v-radio value="document2">
                <template v-slot:label>
                  <div>{{ $t('givenDetails') }}</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn
            color="primary"
            :loading="loading"
            @click="openPrint"
          >
            {{ $t('print') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="grey"
            @click="printDialog = !printDialog"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="accountingDocument"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'blue')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  import Given from './given'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'AccountingTotalList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Given,
      Upload,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      pageCount: 1,
      page: 1,
      excelItems: [],
      selected: [],
      givenDialog: false,
      printDialog: false,
      printItems: [],
      printType: 'document2',
      deletDialog: false,
      groupProp: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      snakbarColor: null,
      uploadDialog: null,
      dialogData: null,
      filter: false,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      type: null,
      headers: null,
      givenItem: null,
      typeItems: null,
      search: null,
    }),
    computed: {
      proListKey () {
        return this.accountingGivenColumnPersistKey
      },
      proListLocked () {
        return this.accountingGivenLockedColumns
      },
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      accountingGivenColumnPersistKey () {
        return 'accounting-given-list-columns-' + (this.$route.name || 'accountingGiven')
      },
      accountingGivenLockedColumns () {
        // Fixed sticky block: select + actions + row + code (no unpin/drag)
        var locked = ['actions', 'number']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      accountingGivenColumnPlugins () {
        // show-select inserts a leading checkbox <th>; pad visibleHeaders so
        // pin/resize/drag index mapping stays aligned with thead cells.
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.accountingGivenLockedColumns,
          anchor: 'number',
          minWidth: 60,
          persistKey: this.accountingGivenColumnPersistKey,
        }
      }
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        this.model = this.selected[0].text
        this.temp = this.selected[0].text
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
    // this.getItems()
    },
    beforeMount () {
      this.typeItems = [
        {
          value: 'initial',
          text: this.$t('initial'),
        },
        {
          value: 'general',
          text: this.$t('general'),
        },
      ]
      this.headers = [
        {
          text: this.$t('#'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 42,
          class: 'pl-action-col',
          cellClass: 'pl-action-col',
        },
        {
          text: this.$t('code'),
          sortable: true,
          value: 'number',
          table: 'financial_given_coding.number',
        },
        {
          text: this.$t('group'),
          sortable: true,
          value: 'group_id',
          table: 'financial_group_coding.name',
        },
        {
          text: this.$t('total'),
          sortable: true,
          value: 'total_id',
          table: 'financial_total_coding.name',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'name',
          table: 'financial_given_coding.name',
        },
        {
          text: this.$t('nature'),
          sortable: true,
          value: 'type',
          table: 'financial_given_coding.type',
        },
        {
          text: this.$t('type'),
          sortable: true,
          value: 'kind',
          table: 'financial_given_coding.kind',
        },
        {
          text: this.$t('tracking'),
          sortable: true,
          value: 'tracking',
          table: 'financial_given_coding.tracking',
        },
        {
          text: this.$t('some'),
          sortable: true,
          value: 'some',
          table: 'financial_given_coding.some',
        },
        {
          text: this.$t('interpretable'),
          sortable: true,
          value: 'interpretable',
          table: 'financial_given_coding.interpretable',
        },
        {
          text: this.$t('currencyFeature'),
          sortable: true,
          value: 'currencyFeature',
          table: 'financial_given_coding.currencyFeature',
        },
        {
          text: this.$t('content'),
          sortable: true,
          value: 'content',
          table: 'financial_given_coding.content',
        },
      ]
      reorderPinnedHeaders(this.headers, {
        locked: this.accountingGivenLockedColumns,
        anchor: 'number',
      })
      this.loadAccountingGivenColumnSettings()
      if (this.input) {
        this.model = this.input
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      loadAccountingGivenColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.accountingGivenColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.accountingGivenLockedColumns,
            anchor: 'number',
          })
          app.$forceUpdate()
        })
      },
      closeDialog () {
        this.getItems()
        this.totalDialog = false
      },
      newGiven (item) {
        this.totalProp = item
        this.givenItem = null
        this.givenDialog = true
      },
      editGiven (item) {
        this.totalProp = item.total
        this.givenItem = item
        this.givenDialog = true
      },
      openDialogPrint (id) {
        this.printItems.push(id)
        this.printDialog = true
      },
      groupPrint () {
        var app = this
        this.selected.map(function (value) {
          app.printItems.push(value.id)
        })
        this.printDialog = true
      },
      openPrint () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accounting', {
          params: {
            print: 'active',
            id: app.printItems,
            type: app.printType,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: 'reportViewer', params: { dataProp: res, reportProp: app.printType } })
            app.printItems = []
          // var routeData = app.$router.resolve({ name: 'reportViewer', params: { dataProp: res } })
          // window.open(routeData.href, '_blank')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      copy (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accounting/' + item.id + '/edit', {
          params: {
            id: item.id,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: 'accounting', params: { itemsProp: res.article } })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      edit (item) {
        this.$router.push({ name: 'accountingEdit', params: { id: item.id, tabName: item.number } })
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accounting', {
          params: {
            givenList: 'active',
            search: app.search,
            total_id: app.$route.params.id,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            type: app.type,
            branch: app.branch,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            fromDate: app.fromDate,
            toDate: app.toDate,
            sortBy: app.sortBy,
            options: app.options,
            tag: app.tag,
            status: app.sellStatus,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.deletDialog = false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'coding/' + this.deleteItem.id, {
          params: {
            level: 'given',
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.deletDialog = false
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'accounting', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            number: (d.total ? d.total.group.number + '' + d.total.number : '') + '' + d.number,
            group: (d.total ? d.total.group.name : ''),
            name: d.name,
            nature: app.$t(d.type),
            type: app.$t(d.kind),
            content: d.content,
          })
        })
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
